<template>
  <div class="banner-container">
    <!-- 头部Banner -->
    <div class="header-banner">
      <div class="header-center">{{ $t('banner.title') }}</div>
      <div class="header-right">
        <div class="icon" @click="onSearch">🔍</div>
        <div class="icon" @click="onMore">⋮</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  name:"ModuleBanner",
  methods: {
    // 搜索 - 使用 Vue Router 跳转
    onSearch() {
      this.$router.push('/search/search');
    },
    // 更多 - 使用 Vant Toast
    onMore() {
      Toast(this.$t('banner.menu'));
    },
  },
};
</script>

<style scoped>
.banner-container {
  width: 100%;
  position: relative;
}

/* 头部Banner样式 */
.header-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;  /* 原 24upx 30upx -> 12px 15px (1upx≈0.5px) */
  background: linear-gradient(135deg, #ff8a5c, #d97c4a);
  color: white;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(217, 124, 74, 0.3);
}

.header-left {
  font-size: 20px;
  font-weight: 400;
  color: white;
  width: 30px;
  text-align: center;
  line-height: 1;
  padding: 5px;
}

.header-center {
  font-size: 18px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.05em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.header-right {
  display: flex;
  gap: 15px;
  color: white;
  font-size: 20px;
}

.header-right .icon {
  cursor: pointer;
  padding: 5px;
  transition: transform 0.2s;
}

.header-right .icon:active {
  transform: scale(0.9);
}
</style>